import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import ReasonService from './reason.service.js'

import { API_RESOURCE } from '@/constants/api.constant'
import { createQueryKey } from '@/lib/react-query.js'

export const useReason = () => {
  const service = new ReasonService()

  const queryClient = useQueryClient()
  const queryKey = createQueryKey(API_RESOURCE.REASON_CONFIG)

  const useFetchReasonsByType = (type) => {
    return useQuery({
      queryKey: [...queryKey.list({}), type],
      queryFn: () => service.fetchReasonsByType(type),
      placeholderData: [],
    })
  }

  const useUpdateReason = () => {
    return useMutation({
      mutationFn: service.updateReason,
      onSuccess: (res) => {
        toast.info('Successfully Update Reasons')
      },
    })
  }

  return {
    useFetchReasonsByType,
    useUpdateReason,
  }
}
